
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AvailableService, InProgress } from '@/features/shipment/types';
import { getPrice } from '@/features/common/helpers';
import { getCutoffTime } from '@/features/shipment/helpers/createShipment';
import DutiesTaxesSidePanel from './DutiesTaxesSidePanel.vue';
import EstimateCostBreakdown from '../EstimateCostBreakdown.vue';

@Component({
  components: {
    EstimateCostBreakdown,
    DutiesTaxesSidePanel,
  },
})
export default class ServiceItemDetails extends Vue {
  @Prop({ required: false, default: false }) show!: boolean;

  @Prop({ required: true }) service!: AvailableService;

  @Prop({ required: false, default: '#8B8BAC' }) color!: string;

  @Prop({ required: false, default: false }) showSavings!: boolean;

  private showDutiesTaxesPanel = false;

  get hasLandedCost(): boolean {
    return !!this.service?.landedCost;
  }

  get inProgressData(): InProgress {
    return this.$store.getters.getInProgress;
  }

  get accountNumberWithCarrier(): string {
    if (!this.service) return '';

    const accountNumber = this.inProgressData.billing.account
      || this.service.usersCarrierAccountNo;

    return `${this.service.carrierCode} #${accountNumber}`;
  }

  get hasSecureshipPrice(): boolean {
    return this.service.totals?.secureship != null
      && this.service.totals.secureship > 0;
  }

  get secureshipPrice(): number {
    return this.service.totals?.secureship || 0;
  }

  get myAccountPrice(): number {
    return this.service.totals?.myAccount || 0;
  }

  get hasCarrierAccount(): boolean {
    return this.hasSecureshipPrice && this.myAccountPrice > 0;
  }

  get additionalSavings(): number {
    if (!this.hasCarrierAccount) return 0;
    const diff = this.myAccountPrice - this.secureshipPrice;
    return diff > 0 ? diff : 0;
  }

  get useSecureshipText(): string {
    if (!this.service) return '';

    const useAccountNumber = this.inProgressData.billing.account
      || !this.service.useSecureship;

    return useAccountNumber
      ? `${this.$t('tables.no')} - ${this.accountNumberWithCarrier}`
      : this.$t('tables.yes') as string;
  }

  get secureshipIconColorSrc(): string | null {
    return this.getIconSrc('icon-use-secureship');
  }

  get pickupIconColorSrc(): string | null {
    return this.getIconSrc('icon-pickup-cost');
  }

  get iconColor(): string {
    switch (this.color) {
      case '#2BC5CB':
        return 'blue';
      case '#FFA43C':
        return 'yellow';
      default:
        return 'gray';
    }
  }

  private getIconSrc(baseName: string): string | null {
    const colorName = this.iconColor;

    try {
      /* eslint-disable global-require */
      return require(`@icons/${baseName}-${colorName}.svg`);
    } catch (e) {
      return null;
    }
  }

  private getCutoffTime = getCutoffTime;

  private getPrice = getPrice;
}
